// extracted by mini-css-extract-plugin
export var hidden = "_or-1";
export var visible = "_or-0";